import { Checkbox, ContentWrapper, SelectMenu, Textbox } from 'components/generic';
import { useState, useContext, useCallback } from 'react';
import { ProfileDetailsContext } from 'providers/profile-provider';
import { getValuesById, dropDown } from 'utils';
import { useSelector } from 'react-redux';
import Images from 'assets/Images';
import { cloneDeep } from 'lodash';

const ChannelConfiguration = props => {
	const context = useContext(ProfileDetailsContext);
	const { createObj, setCreateObj } = context;
	const [editbutton, setEditButton] = useState({ email: false, sms: false, whatsapp: false, viber: false });
	const channelConfig = createObj?.c_channelConfiguration;
	const { c_emailConfiguration, c_smsConfig, c_whatsappConfig, c_viberConfig } = channelConfig;
	const referenceData = useSelector(state => state?.referenceData?.data);

	const handleData = (e, subkey, key) => {
		setCreateObj(prevState => {
			const data = cloneDeep(prevState);
			subkey ? (data.c_channelConfiguration[key][subkey] = e) : (data.c_channelConfiguration[key] = e);
			return data;
		});
	};

	const handleButtonClick = async key => {
		['cancel', 'save'].includes(key) && (await props.onClickButton({ key, createObj: key === 'cancel' ? context.originalObj : createObj }));
		setEditButton({ email: false, sms: false, whatsapp: false, viber: false, [key]: true });
	};

	const buttons = (
		<div className='flex-end'>
			<div className='basic-details__button--cancel' onClick={() => handleButtonClick('cancel')}>
				Cancel
			</div>
			<div className='basic-details__button align-center' onClick={() => handleButtonClick('save')}>
				Save
			</div>
		</div>
	);

	const editButton = useCallback(key => {
		return (
			<div className='basic-details__button align-center' onClick={() => handleButtonClick(key)}>
				<img src={Images['edit-blue']} /> Edit
			</div>
		);
	}, []);

	const getValueMtpl = (array, data) => {
		const a = [];
		array?.map(el => {
			data?.map(e => {
				el?.key === e && a.push(el);
			});
		});
		return a;
	};

	return (
		<>
			<ContentWrapper shadow>
				<div className='row'>
					<div className='col-5'>
						<SelectMenu
							label='Payment Options'
							multiple
							placeholder='Select'
							menuOptions={getValuesById(referenceData, 'rd_channelConfiguration')?.at()?.value}
							value={getValueMtpl(getValuesById(referenceData, 'rd_channelConfiguration')?.at()?.value, createObj?.c_channelConfiguration?.c_configurationOptions)}
							onChange={e => handleData(e, null, 'c_configurationOptions')}
						/>
					</div>
				</div>

				{createObj?.c_channelConfiguration?.c_configurationOptions?.includes('c_emailConfiguration') && (
					<div className='basic-details'>
						<div className='space-between'>
							<h4>Email Configuration</h4>
							{!editbutton?.email && editButton('email')}
						</div>
						<div className='row'>
							{c_emailConfiguration?.c_internalConfig !== 'Y' && (
								<>
									<div className='col-5'>
										<Textbox label='Email ID' placeholder='Enter' display={!editbutton?.email} value={c_emailConfiguration?.c_mailId} onChange={e => handleData(e?.target?.value, 'c_mailId', 'c_emailConfiguration')} />
									</div>
									<div className='col-5'>
										<Textbox
											type='password'
											label='Password'
											display={!editbutton?.email}
											placeholder='Enter'
											value={!editbutton?.email ? '*******' : c_emailConfiguration?.c_password}
											onChange={e => handleData(e?.target?.value, 'c_password', 'c_emailConfiguration')}
										/>
									</div>

									<div className='col-5'>
										<Textbox label='Host' placeholder='Enter' display={!editbutton?.email} value={c_emailConfiguration?.c_host} onChange={e => handleData(e?.target?.value, 'c_host', 'c_emailConfiguration')} />
									</div>
									<div className='col-5'>
										<Textbox label='Service' placeholder='Enter' display={!editbutton?.email} value={c_emailConfiguration?.c_service} onChange={e => handleData(e?.target?.value, 'c_service', 'c_emailConfiguration')} />
									</div>
								</>
							)}
							<div className='col-5'>
								<Checkbox
									last
									content='Use Internal Configuration'
									disabled={!editbutton?.email}
									checked={c_emailConfiguration?.c_internalConfig === 'Y'}
									onClick={e => handleData(e?.target?.checked ? 'Y' : 'N', 'c_internalConfig', 'c_emailConfiguration')}
								/>
							</div>
						</div>

						{editbutton?.email && buttons}
					</div>
				)}

				{createObj?.c_channelConfiguration?.c_configurationOptions?.includes('c_smsConfig') && (
					<div className='basic-details'>
						<div className='space-between'>
							<h4>SMS Configuration</h4>
							{!editbutton?.sms && editButton('sms')}
						</div>
						<div className='row'>
							<div className='col-5'>
								<SelectMenu
									label='SMS Provider'
									placeholder='Enter'
									display={!editbutton?.sms}
									value={getValuesById(dropDown('rd_smsProvider', referenceData), c_smsConfig?.c_smsProvider)}
									menuOptions={dropDown('rd_smsProvider', referenceData)}
									onChange={e => handleData(e, 'c_smsProvider', 'c_smsConfig')}
								/>
							</div>
							<div className='col-5'>
								<Textbox label='API Key' placeholder='Enter' display={!editbutton?.sms} value={c_smsConfig?.c_smsKey} onChange={e => handleData(e?.target?.value, 'c_smsKey', 'c_smsConfig')} />
							</div>
							<div className='col-5'>
								<Textbox label='API Secret' placeholder='Enter' display={!editbutton?.sms} value={c_smsConfig?.c_smsSecret} onChange={e => handleData(e?.target?.value, 'c_smsSecret', 'c_smsConfig')} />
							</div>
						</div>
						{editbutton?.sms && buttons}
					</div>
				)}

				{createObj?.c_channelConfiguration?.c_configurationOptions?.includes('c_whatsappConfig') && (
					<div className='basic-details'>
						<div className='space-between'>
							<h4>WhatsApp Configuration</h4>
							{!editbutton?.whatsapp && editButton('whatsapp')}
						</div>
						<div className='row'>
							<div className='col-5'>
								<Textbox label='Bussiness Number' placeholder='Enter' display={!editbutton?.whatsapp} value={c_whatsappConfig?.c_businessNumber} onChange={e => handleData(e?.target?.value, 'c_businessNumber', 'c_whatsappConfig')} />
							</div>
							<div className='col-5'>
								<Textbox label='API Key' placeholder='Enter0' display={!editbutton?.whatsapp} value={c_whatsappConfig?.c_apiKey} onChange={e => handleData(e?.target?.value, 'c_apiKey', 'c_whatsappConfig')} />
							</div>
						</div>
						{editbutton?.whatsapp && buttons}
					</div>
				)}

				{createObj?.c_channelConfiguration?.c_configurationOptions?.includes('c_viberConfig') && (
					<div className='basic-details'>
						<div className='space-between'>
							<h4>Viber Configuration</h4>
							{!editbutton?.viber && editButton('viber')}
						</div>
						<div className='row'>
							<div className='col-5'>
								<Textbox label='Bussiness Number' display={!editbutton?.viber} placeholder='Enter' value={c_viberConfig?.c_businessNumber} onChange={e => handleData(e?.target?.value, 'c_businessNumber', 'c_viberConfig')} />
							</div>
							<div className='col-5'>
								<Textbox label='API Key' placeholder='Enter' display={!editbutton?.viber} value={c_viberConfig?.c_apiKey} onChange={e => handleData(e?.target?.value, 'c_apiKey', 'c_viberConfig')} />
							</div>
						</div>
						{editbutton?.viber && buttons}
					</div>
				)}
			</ContentWrapper>
		</>
	);
};

export default ChannelConfiguration;
